module.exports = __webpack_public_path__ + "img/logo.9aff57da.png";